import PropTypes from "prop-types";
import ListingContent from "app/pages/Listing/ListingContent/ListingContent";
import { connect } from "react-redux";
import { getListingItems, isAnyListingFilterActive } from "app/pages/Listing/productsSelector";
import { LISTING_ITEM_TYPES } from "app/constants";
import { useFacets } from "app/features/product/productFilters";
import PropsTypes from "prop-types";
import { useDeviceType } from "app/hooks";

const ListingContentContainer = ({ orderedListingItems: listingItems, ...props }) => {
	const { filteredProducts } = useFacets();
	const { isDesktop } = useDeviceType();

	const orderedListingItems = isDesktop ? listingItems : filteredProducts;
	return <ListingContent {...props} orderedListingItems={orderedListingItems} />;
};

ListingContentContainer.propTypes = {
	spotlightUri: PropTypes.string,
};

const mapStateToProps = (state, props) => {
	const orderedListingItems = getListingItems(props.spotlightUri)(state);
	const merchsListingItems = orderedListingItems.filter(item =>
		[LISTING_ITEM_TYPES.MERCH_SIMPLE, LISTING_ITEM_TYPES.MERCH_CAROUSSEL].includes(item.type)
	);
	return {
		isAnyListingFilterActive: isAnyListingFilterActive(state),
		orderedListingItems: props.orderedListingItems
			? props.orderedListingItems
			: orderedListingItems,
		merchsListingItems: merchsListingItems,
		resolution: state.resolution,
		activeProductsFilters: state.productsFilters,
	};
};

ListingContentContainer.propTypes = {
	spotlightUri: PropsTypes.string,
	orderedListingItems: PropsTypes.array,
	merchsListingItems: PropsTypes.array,
	resolution: PropsTypes.string,
	activeProductsFilters: PropsTypes.object,
	isAnyListingFilterActive: PropsTypes.bool,
};

export default connect(mapStateToProps)(ListingContentContainer);
